import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import CardLayout from '../../../../../../../shared/components/card/CardLayout';
import { IBrandCollaborations } from '../../../../../../../model/shared/ICollaboration';

interface ICollaborationsLeftCardProps {
    brands?: IBrandCollaborations[];
    setActiveTab: Dispatch<SetStateAction<string>>;
}

const ExternalProfileCollaborationsLeftCard = ({ brands, setActiveTab }: ICollaborationsLeftCardProps) => {
    const { t } = useTranslation();
    return (
        <>
            <CardLayout classBody="p-3" classCard="mt-3">
                <h6>{t('brand.campaign.book.external_search.collaborations')}:</h6>
                <div className="d-flex align-items-center">
                    {brands?.slice(0, 5).map((brand, index) => (
                        <img
                            key={brand?.id ?? index}
                            width={35}
                            className="rounded-circle object-fit-contain shadow-sm mr-1"
                            src={brand.logoUrl}
                            alt={brand.name}
                        />
                    ))}
                    {(brands?.length ?? 0) > 5 && (
                        <span
                            onClick={() => setActiveTab('collaboration')}
                            className="rounded-circle shadow text-primary font-weight-semi-bold d-flex align-items-center justify-content-center cursor-pointer"
                            style={{ height: 35, width: 35 }}
                        >
                            + {(brands?.length ?? 0) - 5}
                        </span>
                    )}
                </div>
            </CardLayout>
        </>
    );
};

export default ExternalProfileCollaborationsLeftCard;
